import { useAuthStore } from "~/store/auth";

// noinspection JSUnusedGlobalSymbols
export default defineNuxtRouteMiddleware(async () => {
	const authStore = useAuthStore();
	const user = authStore.user;
	if (!user) return navigateTo("/tv/login"); // redirect to login otherwise
	const userAccount = authStore.userAccount;
	if (!userAccount) return navigateTo("/tv/login"); // redirect to user account select page
});
